'use client';

import { PartnerLoader } from '~/components/PartnerLoader/PartnerLoader';
import styles from './JourneyTopBarLoader.module.css';

export function JourneyTopBarLoader() {
  return (
    <div className={styles.topBar}>
      <PartnerLoader interactive variant="topBar" />
    </div>
  );
}
